import React from 'react'

import SessionCustomField from "../../../model2/custom-field/session-custom-field"

type Props = {
    customField: SessionCustomField
}

export default function CustomFieldTitle(props: Props) {

    const title = props.customField ? props.customField.name : 'New custom field';

    return (
        <div className="iv-header header-left header-small-no-separator">
            <div className="title-line">
                <div className="view-name">
                    <div className="ui5-title-app-name max-w-350 ">{title}</div>
                </div>
            </div>
        </div>
    )
}
